import type {
  IntegrationTokenCreateRequest,
  IntegrationTokenCreateResponse,
  IntegrationTokenResponse,
} from 'src/api/ProactApiClient';
import {integrationTokenAdminApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

export const integrationTokensApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getIntegrationTokens: builder.query<
      IntegrationTokenResponse[],
      {instanceId?: number}
    >({
      queryFn: clientQuery(({instanceId}) =>
        integrationTokenAdminApiClient.listTokens(instanceId)
      ),
      providesTags: ['IntegrationTokens'],
    }),
    getIntegrationToken: builder.query<
      IntegrationTokenResponse,
      {id: number; instanceId: number | undefined}
    >({
      queryFn: clientQuery(({id, instanceId}) =>
        integrationTokenAdminApiClient.getToken(id, instanceId)
      ),
      providesTags: ['IntegrationTokens'],
    }),
    createIntegrationToken: builder.mutation<
      IntegrationTokenCreateResponse,
      IntegrationTokenCreateRequest
    >({
      queryFn: clientQuery(request =>
        integrationTokenAdminApiClient.createToken(request)
      ),
      invalidatesTags: ['IntegrationTokens'],
    }),
    revokeIntegrationToken: builder.mutation<
      void,
      {id: number; instanceId: number}
    >({
      queryFn: voidClientQuery(({id, instanceId}) =>
        integrationTokenAdminApiClient.revokeToken(id, instanceId)
      ),
      invalidatesTags: ['IntegrationTokens'],
    }),
  }),
});

export const {
  useGetIntegrationTokensQuery,
  useGetIntegrationTokenQuery,
  useCreateIntegrationTokenMutation,
  useRevokeIntegrationTokenMutation,
} = integrationTokensApi;
